import React from 'react';

import {
  ProviderInfoTabContainer,
  ProviderInfoTab,
  ProviderInfoTabContent
} from './NavigationTabs.styles';

export const enum PrintProviderTab {
  GeneralSettings = 'GENERAL_SETTINGS',
  Users = 'USERS',
  FormatGroups = 'FORMAT_GROUPS',
  PrintOptions = 'PRINT_OPTIONS',
  PostProcessingOptions = 'POST_PROCESSING_OPTIONS'
}

interface Props {
  activeTab: PrintProviderTab;
  onChangeActiveTab: (tab: PrintProviderTab) => any;
}

export const NavigationTabs = ({ activeTab, onChangeActiveTab }: Props) => {
  const providerInfoTabs: {
    label: string;
    key: PrintProviderTab;
  }[] = [
    {
      label: 'General settings',
      key: PrintProviderTab.GeneralSettings
    },
    {
      label: 'Users',
      key: PrintProviderTab.Users
    },
    {
      label: 'Format groups',
      key: PrintProviderTab.FormatGroups
    },
    {
      label: 'Print options',
      key: PrintProviderTab.PrintOptions
    },
    {
      label: 'Post processing options',
      key: PrintProviderTab.PostProcessingOptions
    }
  ];

  const getNavigationTabs = () => {
    return providerInfoTabs.map((tab) => (
      <ProviderInfoTab isActive={activeTab === tab.key}>
        <ProviderInfoTabContent
          onClick={() => {
            onChangeActiveTab(tab.key);
          }}
        >
          {tab.label}
        </ProviderInfoTabContent>
      </ProviderInfoTab>
    ));
  };
  return (
    <ProviderInfoTabContainer>{getNavigationTabs()}</ProviderInfoTabContainer>
  );
};
